import type { Locale } from '../../i18n';

const RU = {
  'tab.shifts': 'Смены и сверка',
  'tab.catalog': 'Каталог и тарифы',
  'tab.materials': 'Материалы',
  'tab.devices': 'Терминалы',
  'tab.attention': 'Требуют возврата',
  'attention.empty': 'Разбирать нечего',
  'attention.emptyHint': 'Нет оплат, по которым клиенту надо вернуть деньги или выяснить итог у провайдера.',
  'attention.when': 'Когда',
  'attention.what': 'Что случилось',
  'attention.kind.refund_required': 'Деньги списаны, но в заказ не проведены — верните клиенту',
  'attention.kind.unresolved': 'Провайдер не назвал итог — проверьте в кабинете провайдера',
  'attention.reason.order_already_paid': 'заказ уже оплачен другим способом',
  'attention.reason.amount_mismatch': 'провайдер подтвердил другую сумму',
  'attention.reference': 'Номер возврата у провайдера',
  'attention.resolve': 'Отметить разобранным',
  'attention.resolved': 'Отмечено',
  'catalog.history': 'История',
  'catalog.historyShow': 'История цены',
  'catalog.historyHide': 'Свернуть',
  'catalog.historyTitle': 'Как менялась цена',
  'catalog.historyLoading': 'Загружаем историю…',
  'catalog.historyEmpty': 'Цена не менялась ни разу',
  'catalog.historyNow': 'по сей день',
  'devices.empty': 'Терминалов нет',
  'devices.emptyHint': 'На этом объекте не поставлено на учёт ни одной кассы.',
  'devices.site': 'Объект',
  'devices.label': 'Название',
  'devices.version': 'Версия',
  'devices.queue': 'Очередь',
  'devices.seen': 'Последняя связь',
  'devices.status': 'Действия',
  'devices.revoke': 'Отозвать доступ',
  'devices.revoked': 'Доступ отозван',
  'devices.revokedLabel': 'доступ отозван',
  'devices.add': 'Поставить кассу на учёт',
  'devices.enroll': 'Поставить на учёт',
  'devices.tokenOnce':
    'Токен показывается один раз: в базе хранится только его хеш. Перенесите его на кассу сейчас.',

  'tab.timesheet': 'Табель',

  'common.site': 'Объект',
  'common.refresh': 'Обновить',
  'common.loading': 'Загрузка…',
  'common.empty': 'Данных нет',
  'common.save': 'Сохранить',
  'common.siteRequired': 'Выберите объект в шапке',
  'common.amount': 'Сумма, ₸',
  'common.comment': 'Комментарий',
  'common.employee': 'Сотрудник',

  'shift.status': 'Состояние',
  'shift.status.open': 'Открыта',
  'shift.status.closed': 'Закрыта',
  'shift.status.reconciled': 'Сверена',
  'shift.openedAt': 'Открыта',
  'shift.closedAt': 'Закрыта',
  'shift.opening': 'Начальный остаток',
  'shift.collected': 'Инкассировано',
  'shift.closing': 'Фактический остаток',
  'shift.expected': 'Ожидается в кассе',
  'shift.difference': 'Расхождение',
  'shift.open': 'Открыть смену',
  'shift.collect': 'Инкассация',
  'shift.close': 'Закрыть смену',
  'shift.reconcile': 'Свести кассу',
  'shift.discrepancy': 'Расхождение требует комментария',
  'shift.movements': 'Движения наличных',
  'shift.kind.opening': 'Открытие',
  'shift.kind.collection': 'Инкассация',
  'shift.kind.payout': 'Выплата',
  'shift.kind.closing': 'Закрытие',
  'shift.cashPayments': 'Наличная выручка',
  'shift.cashRefunds': 'Возвраты наличными',
  'shift.byMethod': 'По способам оплаты',
  'shift.method': 'Способ',
  'shift.methodPayments': 'Оплат',
  'shift.methodCaptured': 'Оплачено',
  'shift.methodRefunded': 'Возвращено',
  'shift.methodNet': 'Чисто',
  'method.cash': 'Наличные',
  'method.card': 'Карта',
  'method.kaspi': 'Kaspi',
  'method.invoice': 'Счёт',
  'method.subscription': 'Подписка',
  'method.bonus': 'Бонусы',

  'catalog.service': 'Услуга',
  'catalog.code': 'Код',
  'catalog.price': 'Цена, ₸',
  'catalog.scope': 'Действие цены',
  'catalog.scope.site': 'Объект',
  'catalog.scope.network': 'Сеть',
  'catalog.size': 'Габарит',
  'catalog.size.any': 'Любой',
  'catalog.noPrice': 'Цена не задана',
  'catalog.newPrice': 'Новая цена',
  'catalog.apply': 'Применить',
  'catalog.hint': 'Новая цена закрывает прежний период и заводит новый — история сохраняется',

  'module.subtitle': 'Смены и касса, каталог с тарифами, материалы и табель',
  'common.siteRequiredHint':
    'Данные кассы всегда относятся к конкретному объекту. Выберите его в шапке слева.',
  'shift.collectTitle': 'Инкассация из открытой смены',
  'shift.collectHint':
    'Наличные изымаются из кассы и уменьшают ожидаемый остаток. Движение попадает в журнал.',
  'shift.collectAmount': 'Сумма инкассации',
  'shift.collected.ok': 'Инкассировано {amount}',
  'material.stockTitle': 'Остатки на объекте',
  'material.emptyReason':
    'Заведите материал и оприходуйте его в формах ниже — остаток выводится из движений, вручную его не задают.',
  'material.derivedHint': 'Остаток считается по движениям: приход минус списания и корректировки.',
  'material.newTitle': 'Новый материал',
  'material.code': 'Код',
  'material.save': 'Завести материал',
  'material.saved': 'Материал сохранён',
  'material.unit.l': 'литр',
  'material.unit.ml': 'миллилитр',
  'material.unit.kg': 'килограмм',
  'material.unit.g': 'грамм',
  'material.unit.pc': 'штука',
  'material.movementTitle': 'Движение материала',
  'material.movementKind': 'Вид движения',
  'material.movementSave': 'Провести',
  'material.movementSaved': 'Движение проведено',
  'material.kind.receipt': 'Приход',
  'material.kind.writeoff': 'Списание',
  'material.kind.adjustment': 'Корректировка',
  'material.qtyHint': 'Для списания и корректировки допускается отрицательное значение',
  'material.normTitle': 'Норма расхода на услугу',
  'material.normHint':
    'Норма списывается автоматически при оформлении заказа. Без норм себестоимость по объектам не сравнить.',
  'material.normQty': 'Расход на одну услугу',
  'material.normSave': 'Сохранить норму',
  'material.normSaved': 'Норма сохранена',
  'timesheet.addTitle': 'Ручная запись табеля',
  'timesheet.day': 'День',
  'timesheet.save': 'Записать',
  'timesheet.saved': 'Записано {minutes} мин',
  'timesheet.willAdd': 'Будет записано {minutes} мин',
  'timesheet.badRange': 'Конец смены должен быть позже начала',
  'timesheet.zeroHint':
    'У сотрудников с заказами ноль минут: без записей табеля выработку со временем не связать.',
  'material.name': 'Материал',
  'material.unit': 'Ед.',
  'material.stock': 'Остаток',
  'material.receipt': 'Приход',
  'material.qty': 'Количество',
  'material.add': 'Оприходовать',

  'timesheet.from': 'С',
  'timesheet.to': 'По',
  'timesheet.minutes': 'Минут',
  'timesheet.orders': 'Заказов',
  'timesheet.revenue': 'Выручка, ₸',
  'timesheet.results': 'Результаты за период',
  'timesheet.entries': 'Записи табеля',
  'timesheet.started': 'Начало',
  'timesheet.ended': 'Конец',
  'catalog.scopePick': 'Где действует',
  'catalog.scopeSiteOnly': 'Только этот объект',
  'catalog.scopeNetwork': 'Вся сеть',
  'services.title': 'Справочник услуг сети',
  'services.hint': 'Услугу заводит и архивирует сеть. Объект выключает у себя то, что не продаёт.',
  'services.name': 'Название',
  'services.category': 'Категория',
  'services.duration': 'Минут',
  'services.status': 'Статус',
  'services.onSite': 'На объекте',
  'services.enabled': 'продаётся',
  'services.disabled': 'выключена',
  'services.enable': 'Включить',
  'services.disable': 'Выключить',
  'services.archive': 'В архив',
  'services.restore': 'Вернуть',
  'services.archived': 'в архиве',
  'services.active': 'действует',
  'services.create': 'Завести услугу',
  'services.created': 'Услуга заведена',
  'packages.title': 'Пакеты услуг',
  'packages.hint': 'Пакет — набор услуг по одной цене. Сеть задаёт состав и сетевую цену, объект — свою цену.',
  'packages.items': 'Состав',
  'packages.networkPrice': 'Цена сети, ₸',
  'packages.sitePrice': 'Цена на объекте, ₸',
  'packages.setSitePrice': 'Своя цена',
  'packages.setNetworkPrice': 'Цена сети',
  'packages.create': 'Завести пакет',
  'packages.created': 'Пакет заведён',
  'packages.pickServices': 'Отметьте услуги пакета',
  'packages.empty': 'Пакетов пока нет',
  'timesheet.period': 'Период',
  'timesheet.show': 'Показать',
  'timesheet.export': 'Выгрузить CSV',
  'timesheet.shifts': 'Смен',
  'timesheet.kind.shift': 'смена',
  'timesheet.kind.manual': 'вручную',
  'timesheet.revenueHint': 'Выручка — только оплаченные и не отменённые заказы, за вычетом возвратов.',
  'shift.reconcileOwn': 'Сверяет управляющий, который в смене не работал.',
} as const;

const KK: Record<keyof typeof RU, string> = {
  'tab.shifts': 'Ауысымдар және салыстыру',
  'tab.catalog': 'Каталог және тарифтер',
  'tab.materials': 'Материалдар',
  'tab.devices': 'Терминалдар',
  'tab.attention': 'Қайтаруды күтеді',
  'attention.empty': 'Талдайтын ештеңе жоқ',
  'attention.emptyHint': 'Клиентке ақшаны қайтару немесе провайдерден нәтижені анықтау керек төлем жоқ.',
  'attention.when': 'Қашан',
  'attention.what': 'Не болды',
  'attention.kind.refund_required': 'Ақша есептен шығарылды, бірақ тапсырысқа өткізілмеді — клиентке қайтарыңыз',
  'attention.kind.unresolved': 'Провайдер нәтижені айтпады — провайдер кабинетінде тексеріңіз',
  'attention.reason.order_already_paid': 'тапсырыс басқа тәсілмен төленген',
  'attention.reason.amount_mismatch': 'провайдер басқа соманы растады',
  'attention.reference': 'Провайдердегі қайтару нөмірі',
  'attention.resolve': 'Талданды деп белгілеу',
  'attention.resolved': 'Белгіленді',
  'catalog.history': 'Тарих',
  'catalog.historyShow': 'Баға тарихы',
  'catalog.historyHide': 'Жию',
  'catalog.historyTitle': 'Баға қалай өзгерді',
  'catalog.historyLoading': 'Тарихты жүктеп жатырмыз…',
  'catalog.historyEmpty': 'Баға ешқашан өзгермеген',
  'catalog.historyNow': 'бүгінге дейін',
  'devices.empty': 'Терминалдар жоқ',
  'devices.emptyHint': 'Бұл нысанда бірде-бір касса есепке қойылмаған.',
  'devices.site': 'Нысан',
  'devices.label': 'Атауы',
  'devices.version': 'Нұсқа',
  'devices.queue': 'Кезек',
  'devices.seen': 'Соңғы байланыс',
  'devices.status': 'Әрекеттер',
  'devices.revoke': 'Қолжетімділікті қайтарып алу',
  'devices.revoked': 'Қолжетімділік қайтарып алынды',
  'devices.revokedLabel': 'қолжетімділік жоқ',
  'devices.add': 'Кассаны есепке қою',
  'devices.enroll': 'Есепке қою',
  'devices.tokenOnce':
    'Токен бір рет қана көрсетіледі: дерекқорда тек оның хеші сақталады. Оны қазір кассаға көшіріңіз.',

  'tab.timesheet': 'Табель',

  'common.site': 'Нысан',
  'common.refresh': 'Жаңарту',
  'common.loading': 'Жүктелуде…',
  'common.empty': 'Дерек жоқ',
  'common.save': 'Сақтау',
  'common.siteRequired': 'Жоғарыдан нысанды таңдаңыз',
  'common.amount': 'Сома, ₸',
  'common.comment': 'Түсініктеме',
  'common.employee': 'Қызметкер',

  'shift.status': 'Күйі',
  'shift.status.open': 'Ашық',
  'shift.status.closed': 'Жабық',
  'shift.status.reconciled': 'Салыстырылған',
  'shift.openedAt': 'Ашылды',
  'shift.closedAt': 'Жабылды',
  'shift.opening': 'Бастапқы қалдық',
  'shift.collected': 'Инкассацияланды',
  'shift.closing': 'Нақты қалдық',
  'shift.expected': 'Кассада күтіледі',
  'shift.difference': 'Айырма',
  'shift.open': 'Ауысымды ашу',
  'shift.collect': 'Инкассация',
  'shift.close': 'Ауысымды жабу',
  'shift.reconcile': 'Кассаны салыстыру',
  'shift.discrepancy': 'Айырма түсініктемені талап етеді',
  'shift.movements': 'Қолма-қол ақша қозғалысы',
  'shift.kind.opening': 'Ашылу',
  'shift.kind.collection': 'Инкассация',
  'shift.kind.payout': 'Төлем',
  'shift.kind.closing': 'Жабылу',
  'shift.cashPayments': 'Қолма-қол түсім',
  'shift.cashRefunds': 'Қолма-қол қайтарымдар',
  'shift.byMethod': 'Төлем тәсілдері бойынша',
  'shift.method': 'Тәсіл',
  'shift.methodPayments': 'Төлемдер',
  'shift.methodCaptured': 'Төленді',
  'shift.methodRefunded': 'Қайтарылды',
  'shift.methodNet': 'Таза',
  'method.cash': 'Қолма-қол',
  'method.card': 'Карта',
  'method.kaspi': 'Kaspi',
  'method.invoice': 'Шот бойынша',
  'method.subscription': 'Жазылым',
  'method.bonus': 'Бонустар',

  'catalog.service': 'Қызмет',
  'catalog.code': 'Коды',
  'catalog.price': 'Бағасы, ₸',
  'catalog.scope': 'Баға қолданысы',
  'catalog.scope.site': 'Нысан',
  'catalog.scope.network': 'Желі',
  'catalog.size': 'Габарит',
  'catalog.size.any': 'Кез келген',
  'catalog.noPrice': 'Баға белгіленбеген',
  'catalog.newPrice': 'Жаңа баға',
  'catalog.apply': 'Қолдану',
  'catalog.hint': 'Жаңа баға алдыңғы кезеңді жауып, жаңасын ашады — тарих сақталады',

  'module.subtitle': 'Ауысымдар мен касса, тарифті каталог, материалдар және табель',
  'common.siteRequiredHint':
    'Касса деректері әрқашан нақты нысанға қатысты. Оны сол жақ жоғарыдан таңдаңыз.',
  'shift.collectTitle': 'Ашық ауысымнан инкассация',
  'shift.collectHint':
    'Қолма-қол ақша кассадан алынады және күтілетін қалдықты азайтады. Қозғалыс журналға түседі.',
  'shift.collectAmount': 'Инкассация сомасы',
  'shift.collected.ok': '{amount} инкассацияланды',
  'material.stockTitle': 'Нысандағы қалдықтар',
  'material.emptyReason':
    'Төмендегі формаларда материалды енгізіп, кіріске алыңыз — қалдық қозғалыстардан шығады.',
  'material.derivedHint': 'Қалдық қозғалыстар бойынша есептеледі: кіріс минус шығыс пен түзету.',
  'material.newTitle': 'Жаңа материал',
  'material.code': 'Коды',
  'material.save': 'Материал енгізу',
  'material.saved': 'Материал сақталды',
  'material.unit.l': 'литр',
  'material.unit.ml': 'миллилитр',
  'material.unit.kg': 'келі',
  'material.unit.g': 'грамм',
  'material.unit.pc': 'дана',
  'material.movementTitle': 'Материал қозғалысы',
  'material.movementKind': 'Қозғалыс түрі',
  'material.movementSave': 'Өткізу',
  'material.movementSaved': 'Қозғалыс өткізілді',
  'material.kind.receipt': 'Кіріс',
  'material.kind.writeoff': 'Шығыс',
  'material.kind.adjustment': 'Түзету',
  'material.qtyHint': 'Шығыс пен түзету үшін теріс мән беруге болады',
  'material.normTitle': 'Қызметке шығын нормасы',
  'material.normHint':
    'Норма тапсырыс ресімделгенде автоматты түрде шығысқа жазылады.',
  'material.normQty': 'Бір қызметке шығын',
  'material.normSave': 'Норманы сақтау',
  'material.normSaved': 'Норма сақталды',
  'timesheet.addTitle': 'Табельдің қолмен жазбасы',
  'timesheet.day': 'Күн',
  'timesheet.save': 'Жазу',
  'timesheet.saved': '{minutes} мин жазылды',
  'timesheet.willAdd': '{minutes} мин жазылады',
  'timesheet.badRange': 'Ауысым соңы басынан кейін болуы керек',
  'timesheet.zeroHint':
    'Тапсырысы бар қызметкерлерде нөл минут: табель жазбаларынсыз өнімділікті уақытпен байланыстыру мүмкін емес.',
  'material.name': 'Материал',
  'material.unit': 'Өлш.',
  'material.stock': 'Қалдық',
  'material.receipt': 'Кіріс',
  'material.qty': 'Саны',
  'material.add': 'Кіріске алу',

  'timesheet.from': 'Бастап',
  'timesheet.to': 'Дейін',
  'timesheet.minutes': 'Минут',
  'timesheet.orders': 'Тапсырыс',
  'timesheet.revenue': 'Түсім, ₸',
  'timesheet.results': 'Кезең нәтижелері',
  'timesheet.entries': 'Табель жазбалары',
  'timesheet.started': 'Басы',
  'timesheet.ended': 'Соңы',
  'catalog.scopePick': 'Қайда қолданылады',
  'catalog.scopeSiteOnly': 'Тек осы нысан',
  'catalog.scopeNetwork': 'Бүкіл желі',
  'services.title': 'Желінің қызметтер анықтамалығы',
  'services.hint': 'Қызметті желі енгізеді және мұрағаттайды. Нысан өзі сатпайтынын өшіреді.',
  'services.name': 'Атауы',
  'services.category': 'Санаты',
  'services.duration': 'Минут',
  'services.status': 'Мәртебесі',
  'services.onSite': 'Нысанда',
  'services.enabled': 'сатылады',
  'services.disabled': 'өшірілген',
  'services.enable': 'Қосу',
  'services.disable': 'Өшіру',
  'services.archive': 'Мұрағатқа',
  'services.restore': 'Қайтару',
  'services.archived': 'мұрағатта',
  'services.active': 'қолданыста',
  'services.create': 'Қызмет енгізу',
  'services.created': 'Қызмет енгізілді',
  'packages.title': 'Қызмет пакеттері',
  'packages.hint': 'Пакет — бір бағадағы қызметтер жиынтығы. Желі құрамын және желілік бағаны, нысан — өз бағасын белгілейді.',
  'packages.items': 'Құрамы',
  'packages.networkPrice': 'Желі бағасы, ₸',
  'packages.sitePrice': 'Нысандағы баға, ₸',
  'packages.setSitePrice': 'Өз бағасы',
  'packages.setNetworkPrice': 'Желі бағасы',
  'packages.create': 'Пакет енгізу',
  'packages.created': 'Пакет енгізілді',
  'packages.pickServices': 'Пакет қызметтерін белгілеңіз',
  'packages.empty': 'Әзірге пакеттер жоқ',
  'timesheet.period': 'Кезең',
  'timesheet.show': 'Көрсету',
  'timesheet.export': 'CSV түсіру',
  'timesheet.shifts': 'Ауысым',
  'timesheet.kind.shift': 'ауысым',
  'timesheet.kind.manual': 'қолмен',
  'timesheet.revenueHint': 'Түсім — тек төленген және жойылмаған тапсырыстар, қайтарулар шегеріледі.',
  'shift.reconcileOwn': 'Ауысымда жұмыс істемеген басқарушы салыстырады.',
};

export type PosKey = keyof typeof RU;
export type PosTranslate = (
  key: PosKey,
  params?: Readonly<Record<string, string | number>>,
) => string;

export function makePosT(locale: Locale): PosTranslate {
  const dict: Record<string, string> = locale === 'kk' ? KK : RU;
  return (key, params) => {
    const template = dict[key] ?? key;
    if (!params) return template;
    return template.replace(/\{(\w+)\}/g, (match, name: string) =>
      params[name] === undefined ? match : String(params[name]),
    );
  };
}

/** Единый формат денег на всю админку — вместе с символом валюты. */
export { formatMoney as money } from '../../shell/format';
